'use strict';

const Backbone = require('backbone');

/**
 * 抽象的な設計と具体的な設計/成果物の間の相互参照を実現する Entity
 */
module.exports = Backbone.Model.extend({
    default: {
        model: null,
        specific: null
    },

    getModel: function() {
        return this.get('model');
    },

    getSpecific: function() {
        return this.get('specific');
    }
});


// WEBPACK FOOTER //
// ./balus/domain/entity/allocation/index.js